import { render, staticRenderFns } from "./RemoteOpen.vue?vue&type=template&id=2a7aec97&"
import script from "./RemoteOpen.vue?vue&type=script&lang=js&"
export * from "./RemoteOpen.vue?vue&type=script&lang=js&"
import style0 from "./RemoteOpen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports